import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { unloadDepart, viewDepart } from '../../modules/deptModule/depart';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import UserMenusTemplate from '../../components/usermenumng/UserMenusTemplate';
import { unloadEmployee, viewEmployee } from '../../modules/empModule/employee';
import UserMenuListContainer from './UserMenuListContainer';


const UserMenusContainer = () => {

    const { id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const { employee, error, loading } = useSelector(
        ({ empModule, loading }) => ({
          employee: empModule.employee.employee,
          error: empModule.employee.error,
          loading: loading['employee/VIEW_EMPLOYEE'],
        }),
      );


    useEffect(() => {
        dispatch(viewEmployee(id));

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadEmployee());
        };
    }, [dispatch, id]);

    


    


    return (
       <UserMenusTemplate user={employee} loading={loading} error={error}>
           <UserMenuListContainer user={employee}/>
       </UserMenusTemplate>
    )
}

export default UserMenusContainer